export const VERSION = {
    "version": "3.9.0"
};
